import type { Review } from "@/types/review"

export const mockReviews: Review[] = [
  {
    id: "1",
    name: "Maria van der Berg",
    role: "Financial Controller",
    company: "TechnoPlus B.V.",
    companySize: "50-100 employees",
    sector: "ICT and Telecom",
    rating: 4,
    title: "Solid solution for medium-sized companies",
    fullReview:
      "After 2 years of intensive use of this system, I am generally satisfied. The implementation went smoothly with good guidance from the implementation team. The financial modules are extensive and cover all the needs of our company. Especially the reporting capabilities are strong - we can now make monthly closings much faster. The user interface is intuitive, although some screens seem a bit busy. The connection with our webshop works perfectly and inventory mutations are updated in real-time.",
    pros: ["Extensive financial reporting", "Good webshop integration", "Stable system", "Responsive customer service"],
    cons: ["Sometimes slow loading times", "Limited customization options", "Relatively high license costs"],
    helpful: 12,
    createdAt: "2024-01-15T10:30:00Z",
    productKey: "mock",
    status: "approved",
    verified: true,
  },
  {
    id: "2",
    name: "Jan Pietersen",
    role: "Operations Manager",
    company: "LogiFlow Netherlands",
    companySize: "100-250 employees",
    sector: "Logistics and Transport",
    rating: 5,
    title: "Excellent for logistics processes",
    fullReview:
      "This system has completely transformed our logistics processes. The inventory module is exceptionally advanced with real-time tracking and automatic replenishment. The integration with our transport partners runs seamlessly via EDI connections. What has helped us most is the workflow automation - orders are now automatically processed and prioritized. The mobile app enables our warehouse staff to make mutations directly from the work floor. The ROI was visible within 8 months through efficiency gains.",
    pros: ["Advanced inventory module", "Excellent EDI integrations", "Mobile app for warehouse", "Fast ROI"],
    cons: ["Complex initial setup", "Lots of training needed for staff"],
    helpful: 18,
    createdAt: "2024-02-20T14:15:00Z",
    productKey: "mock",
    status: "approved",
    verified: true,
  },
  {
    id: "3",
    name: "Sandra Bakker",
    role: "HR Director",
    company: "InnovateCorp",
    companySize: "25-50 employees",
    sector: "Services",
    rating: 3,
    title: "Mixed experiences with HR module",
    fullReview:
      "We have been using this system for 18 months now, mainly for HR and payroll administration. The basic functionalities like leave registration and personnel files work properly. The payroll module is accurate and complies with Dutch legislation. However, we miss modern HR features like performance management and talent development tools. The reporting capabilities are limited compared to specialized HR systems. The user interface feels somewhat dated. For a small company it is sufficient, but for growth we probably need an upgrade.",
    pros: ["Accurate payroll processing", "Good compliance", "Stable operation", "Affordable for small businesses"],
    cons: ["Limited HR functionalities", "Dated interface", "Few reporting options", "No mobile access"],
    helpful: 8,
    createdAt: "2024-03-10T09:45:00Z",
    productKey: "mock",
    status: "approved",
    verified: false,
  },
  {
    id: "4",
    name: "Robert de Vries",
    role: "IT Manager",
    company: "Manufacturing Solutions",
    companySize: "250+ employees",
    sector: "Production and Industry",
    rating: 4,
    title: "Powerful production module, challenging implementation",
    fullReview:
      "As IT Manager, I have guided the complete implementation of this system for our production environment. The production module is impressive - supports multi-level BOMs, routings, and capacity planning. The MRP functionality works excellently and has improved our planning efficiency by 30%. The APIs are well documented which facilitated integration with our existing systems. However, the implementation was complex and took longer than planned. The learning curve for end users is steep. Performance is good at normal loads, but we notice delays during peak loads.",
    pros: [
      "Extensive production module",
      "Good API documentation",
      "Strong MRP functionality",
      "Flexible configuration",
    ],
    cons: [
      "Complex implementation",
      "Steep learning curve",
      "Performance issues during peak loads",
      "High consultancy costs",
    ],
    helpful: 15,
    createdAt: "2024-01-25T16:20:00Z",
    productKey: "mock",
    status: "approved",
    verified: true,
  },
]

export const companySizeKeys = [
  "oneToTenEmployees",
  "elevenToTwentyFiveEmployees",
  "twentyFiveToFiftyEmployees",
  "fiftyToHundredEmployees",
  "hundredToTwoFiftyEmployees",
  "twoFiftyToFiveHundredEmployees",
  "fiveHundredToOneThousandEmployees",
  "moreThanOneThousandEmployees",
] as const

export type CompanySizeKey = (typeof companySizeKeys)[number]

export const sectorKeys = [
  "productionAndIndustry",
  "trade",
  "logisticsAndTransport",
  "constructionAndInstallation",
  "services",
  "healthcareAndWelfare",
  "educationAndResearch",
  "realEstateAndBuildingManagement",
  "agriculturalSector",
  "energyAndEnvironment",
  "governmentAndPublicSector",
  "nonProfitAndNgos",
  "mediaCulturalAndCreativeSector",
  "ictAndTelecom",
  "tourismHospitalityAndRecreation",
] as const

export type SectorKey = (typeof sectorKeys)[number]
